import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { usePageOwner } from '../../hooks/usePageOwner';
import { useCharityAdmin } from '../../hooks/useCharityAdmin';
import styles from './Editbar.scss';
import { useIsMounted } from '../../hooks/useIsMounted';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';

interface EditbarProps {
  adminLink: string;
}

const Editbar: FunctionComponent<EditbarProps> = ({ adminLink }) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { isPageOwner } = usePageOwner();
  const { isCharityAdmin } = useCharityAdmin();
  const { isStaff } = useAuthenticateUser();

  const isMounted = useIsMounted();

  if (!isMounted) {
    return null;
  }

  if (isPageOwner || isCharityAdmin || isStaff) {
    return (
      <div className={styles.fullScreenWrapper}>
        <div className={styles.contentWrapper}>
          <a
            href={adminLink}
            className={classNames('jg-btn--ghost', 'jg-btn', styles.button)}
          >
            {t('page.editPage', 'Edit your page')}
          </a>
        </div>
      </div>
    );
  }
  return null;
};

export default Editbar;
